import {applyMiddleware, createStore} from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';
import {composeWithDevTools} from "@redux-devtools/extension";


export default function configureStoreAccountButton(initialState) {
    if (process.env.NODE_ENV === 'production') {
        return createStore(rootReducer, initialState, applyMiddleware(
            thunkMiddleware
        ));
    }

    const store = createStore(
        rootReducer,
        initialState,
        //redux dev tools
        composeWithDevTools(applyMiddleware(thunkMiddleware))
    );

    //hot module react
    if (module.hot) {
        module.hot.accept('../reducers', () =>
            store.replaceReducer(rootReducer)
        );
    }

    return store;
}
